const base = '/dento/images';

export const images = {
  logo: `${base}/logo.png`,
  heroDashboard: `${base}/hero-dashboard.png`,
  clinicDashboard: `${base}/dashboard.png`,
  projectMgmt: `${base}/patient-app-screen.png`,
  financial: `${base}/clinic-send-doc.png`,
  mobileApp: `${base}/mobile-app.png`,
  webApp: `${base}/dashboard.png`,
  mobileUi: `${base}/gUEFVWinvZ7dMZa0mUhNZWHNj3U.png`,
  budgetUi: `${base}/thBhwyY3D4d8TRQEbrMU6zSvz8.png`,
  testimonialAvatar: `${base}/lTRuCxkmxeIKqNbj2JiXUFWgdw.png`,
  cloud: `${base}/cloud.png`,
  benefitLarge1: `${base}/g690a9Fxc6Y5G69sPCSKq4vjw.png`,
  benefitLarge2: `${base}/WkcfohGmGxdaZXOQkB8urlpwXg.png`,
  blog1: `${base}/Et6DumDmh2RQ0iDyCSQ6tfsZ8.jpg`,
  blog2: `${base}/UQ3VAeUsm7aRhKUqekI3Sx8YmY.jpg`,
  blog3: `${base}/dOXROHKlycOnbn8lmjcAsLs.jpg`,
  blog4: `${base}/r6zjSUgLQkP33zYAqzN6hO1MW6g.jpg`,
  communityX: `${base}/YJ3wO9vQ3HS4wmE05zXN33kEM4.png`,
  communityYoutube: `${base}/2Ej8Skea1eSs8GzApuNwBRh3oFU.png`,
  authorAvatar: `${base}/gxb6A1j9Y0wXrhIBrMQD21JI.png`,
  ctaBg: `${base}/vp3FQ8cQAX82fBniYARy66SgROY.png`,
};

export const tickerLogos = [
  `${base}/GAPrNTGokhXDrpYlaBRMcEI1eb4.svg`,
  `${base}/JLKCf0k33nXsBtTOLxbgoXjv6Ss.svg`,
  `${base}/OMudghgJ8cOQBZy5AnYNjXwFYqo.svg`,
  `${base}/021VVvexJAvEOe3HzihhFr7Vc.svg`,
  `${base}/11KSGbIZoRSg4pjdnUoif6MKHI.svg`,
  `${base}/6tTbkXggWgQCAJ4DO2QEdXXmgM.svg`,
  `${base}/rIwx0YXJUHFQJwp5wOOGPGDHtfg.svg`,
  `${base}/vEwVsUctVIZOnnUDjiFAZnBfQ0.svg`,
  `${base}/x8lLoogiCtXVj0rROYScrZZvHMk.svg`,
];

export const benefitIcons = [
  `${base}/3KGY9KbY0xx6nriJohA0sGcmC80.svg`,
  `${base}/7z8nIe5VNDZRfkorYvrXVIwyKac.svg`,
  `${base}/CETEJNIiyGnwauuXU1kWh7qEVg.svg`,
  `${base}/G0nzyLwjIqnhroSjOYxRMDHQ0dI.svg`,
  `${base}/JzxexaeJ1VrTA2beNFkJv1XxAU.svg`,
  `${base}/PQwDHpHHo6LkBn288aRKPox3tY.svg`,
  `${base}/WZBieSq9HMlZV6YHFeHuWZrubY.svg`,
];
